import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { parkedResponseSchema } from '@shared/api';
import type { ParkedRow } from '@shared/types';
import { api, qs } from '@web/lib/api';
import { keys } from '@web/lib/keys';

/**
 * The pull queue.
 *
 * The server already returns longest-wait-first and the client keeps that
 * order: unlike the board, this list is explicitly a queue, and re-ranking it
 * on the client would mean two different ideas of "next" between two operators
 * looking at the same screen.
 */
export function useParked(): UseQueryResult<ParkedRow[]> {
  return useQuery({
    queryKey: keys.parked,
    queryFn: async () => {
      const response = await api.get(`/api/parked${qs({ limit: 100 })}`, parkedResponseSchema);
      return response.rows;
    },
  });
}
